import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Chip,
  Grid,
  styled
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Assignment as AssignmentIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  background: 'rgba(18, 18, 18, 0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.spacing(2),
  border: '1px solid rgba(255, 255, 255, 0.1)',
  padding: theme.spacing(3),
  marginBottom: theme.spacing(2),
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
  }
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  padding: '6px 16px',
  textTransform: 'none',
  marginRight: theme.spacing(1),
}));

const ExpenseQueueContent = ({ 
  expenses, 
  onApprove, 
  onReject, 
  onRequestDocs, 
  onViewDetails 
}) => {
  return (
    <Box>
      {expenses.map((expense) => (
        <StyledPaper key={expense.id} elevation={0}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <Typography variant="h6" sx={{ 
                background: 'linear-gradient(45deg, #00BCD4, #4CAF50)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                ${expense.amount?.toLocaleString()}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Submitted by {expense.requestor}
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Typography variant="body1">{expense.purpose}</Typography>
              <Typography variant="caption" color="text.secondary">
                {new Date(expense.submissionDate).toLocaleDateString()}
              </Typography>
            </Grid>

            <Grid item xs={12} md={4} sx={{ textAlign: 'right' }}>
              <ActionButton
                startIcon={<VisibilityIcon />}
                onClick={() => onViewDetails(expense)}
                variant="outlined"
                color="primary"
              >
                View Details
              </ActionButton>
              <ActionButton
                startIcon={<CheckCircleIcon />}
                onClick={() => onApprove(expense.id)}
                variant="contained"
                color="success"
              >
                Approve
              </ActionButton>
              <ActionButton
                startIcon={<CancelIcon />}
                onClick={() => onReject(expense.id)}
                variant="contained"
                color="error"
              >
                Reject
              </ActionButton>
              <ActionButton
                startIcon={<AssignmentIcon />}
                onClick={() => onRequestDocs(expense.id)}
                variant="contained"
                color="warning"
              >
                Request Docs
              </ActionButton>
            </Grid>
          </Grid>
        </StyledPaper>
      ))}
    </Box>
  );
};

export default ExpenseQueueContent; 